module.exports = __webpack_public_path__ + "img/edi-6.c9929f0a.png";